import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'scaling',
});
export const pickReplicaRouteRef = createRouteRef({
  id: 'pick-replica',
});

export const updateServiceReplicaRouteRef = createRouteRef({
  id: 'update-service-replica',
});

export const previewRouteRef = createRouteRef({
  id: 'previewPageReplica',
});

export const serviceReplicaRouteRef = createRouteRef({
  id: 'serviceReplicaPage',
});
